import { render, staticRenderFns } from "./SettingsLocations.vue?vue&type=template&id=75ea775a&scoped=true"
import script from "./SettingsLocations.vue?vue&type=script&lang=js"
export * from "./SettingsLocations.vue?vue&type=script&lang=js"
import style0 from "./SettingsLocations.vue?vue&type=style&index=0&id=75ea775a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ea775a",
  null
  
)

export default component.exports